import { configureStore } from '@reduxjs/toolkit';
import authReducer from './authSlice';
import tutorReducer from './tutorSlice';
import tableReducer from './tableSlice';
import userProfileReducer from './userProfileSlice';
import tutorProfileReducer from './tutorProfileSlice';
import clientProfileReducer from './clientProfileSlice';
import invoiceProfileReducer from './invoiceProfileSlice';
import orderProfileReducer from './orderProfileSlice';
import studentReducer from './studentSlice';
import callSlice from './callSlice';
import contractProfileReducer from './contractProfileSlice';
import { loadState, saveState } from './browser-storage';
import { debounce } from "../helpers/helpers";
import statesSlice from './statesSlice';
import settingsSlice from './settingsSlice';
import ordersSlice from './ordersSlice';
import incidenceProfileReducer from './incidenceProfileSlice';
import leadProfileReducer from './leadProfileSlice';

const store = configureStore({
  reducer: {
    //@ts-ignore
    auth: authReducer,
    tutor: tutorReducer,
    table: tableReducer,
    userProfile: userProfileReducer,
    tutorProfile: tutorProfileReducer,
    clientProfile: clientProfileReducer,
    callProfile: callSlice,
    student: studentReducer,
    contractProfile: contractProfileReducer,
    states: statesSlice,
    settings: settingsSlice,
    orders: ordersSlice,
    invoiceProfile: invoiceProfileReducer,
    incidenceProfile: incidenceProfileReducer,
    orderProfile: orderProfileReducer,
    leadProfile: leadProfileReducer
  },
  preloadedState: loadState(),
});

// here we subscribe to the store changes
store.subscribe(
  // we use debounce to save the state once each 800ms
  // for better performances in case multiple changes occur in a short time
  debounce(() => {
    saveState(store.getState());
  }, 800));

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export default store;